import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { ReportManagementCsvPreviewItem } from '../types/reportsManagement/ReportManagementCsvPreviewItem';
import { ReportManagementModalView } from '../types/reportsManagement/ReportManagementModalView';

export const REPORTSMANAGEMENT_HEADER = [
  {
    label: '日付',
    sortable: true,
    sortKey: 'date',
    width: '200px',
  },
  {
    label: '社員コード',
    sortable: false,
    sortKey: '',
    width: '100px',
  },
  { label: '氏名', sortable: false, sortKey: '', width: '150px' },
  { label: 'PJ No', sortable: false, sortKey: '', width: '220px' },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  { label: '工数A', sortable: false, sortKey: '', width: '80px' },
  { label: '工数B', sortable: false, sortKey: '', width: '80px' },
  { label: '工数C', sortable: false, sortKey: '', width: '80px' },
  { label: '工数D', sortable: false, sortKey: '', width: '80px' },
  { label: '工数E', sortable: false, sortKey: '', width: '80px' },
  { label: '始業時間', sortable: false, sortKey: '', width: '180px' },
  { label: '終業時間', sortable: false, sortKey: '', width: '180px' },
  { label: '工数', sortable: false, sortKey: '', width: '80px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];

export const REPORTSMANAGEMENT_MANAGEMENT_CSV_MODAL_FIELDS: FieldDescriptor<ReportManagementCsvPreviewItem>[] =
  [
    { label: '対象期間', key: 'month', type: 'date' },
    { label: 'プロジェクト名', key: 'projectName', type: 'text' },
  ];

export const REPORTS_MANAGEMENT_MODAL_FIELDS: FieldDescriptor<ReportManagementModalView>[] =
  [
    { label: '日付', key: 'date', type: 'date' },
    { label: '社員コード', key: 'employeeCode', type: 'text' },
    { label: '氏名', key: 'employeeName', type: 'text' },
    { label: 'PJ No', key: 'projectNo', type: 'text' },
    { label: 'プロジェクト名', key: 'projectName', type: 'text' },
    { label: '工数A', key: 'manHoursA', type: 'checkbox' },
    { label: '工数B', key: 'manHoursB', type: 'checkbox' },
    { label: '工数C', key: 'manHoursC', type: 'checkbox' },
    { label: '工数D', key: 'manHoursD', type: 'checkbox' },
    { label: '工数E', key: 'manHoursE', type: 'checkbox' },
    { label: '始業時間', key: 'startTime', type: 'text' },
    { label: '終業時間', key: 'endTime', type: 'text' },
    { label: '工数合計', key: 'manHoursTotal', type: 'text' },
  ];
